module.exports = __webpack_public_path__ + "img/title.3c76f090.png";